import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import Toggle from 'components/Form/Toggle/Toggle'

import HeadMark from './components/HeadMark/HeadMark'

import arrow from './i/arrow.svg'

import styles from './Group.module.scss'

const Group = ({ group, schema, blockId, onUpdate, children, openModalByName, values }) => {
    const { t } = useTranslation()
    const [isShowControls, setIsShowControls] = useState(false)
    const [mainControl, setMainControl] = useState(null)

    useEffect(() => {
        if (group.tab?.isOpenByDefault) setIsShowControls(true)
    }, [])

    useEffect(() => {
        if (group?.tab) {
            if (!group.tab.value) {
                setMainControl(null)
                return
            }
            const el = schema.find(s => s.name === group.tab.value)
            if (!el) {
                setMainControl(null)
                return
            }

            setMainControl(el)
        } else {
            setMainControl(null)
        }
    }, [schema, group])

    const onTabClick = () => {
        if (!!group.tab.forceOpenModalName && !mainControl.value) openModalByName(group.tab.forceOpenModalName)
        if (!!mainControl) return
        setIsShowControls(!isShowControls)
    }

    useEffect(() => {
        if (mainControl) setIsShowControls(mainControl.value)
    }, [mainControl])

    return (
        <li
            className={classNames(styles.groupBlock, {
                [styles.isDisabledGroupBlock]: group.isDisabled,
                [styles.isHasTabGroupBlock]: !!group.tab,
            })}
        >
            {!!group.tab ? (
                <div className={styles.groupTab}>
                    <div
                        className={classNames(styles.head, { [styles.isUnckickableHead]: !!mainControl })}
                        onClick={onTabClick}
                    >
                        <div className={styles.headContent}>
                            {!!group.tab.icon && <img className={styles.headIcon} src={group.tab.icon} />}
                            <div className={styles.headLabel}>{group.tab.label}</div>
                            {group.tab.isNew && <HeadMark text="new" />}
                            {group.tab.isBeta && <HeadMark text="beta" />}
                        </div>
                        <div className={styles.actions}>
                            {!!mainControl ? (
                                <>
                                    <Toggle
                                        sliderWrapperClassName={styles.toggleWrapper}
                                        value={mainControl.value}
                                        onUpdate={v => onUpdate(blockId, { [mainControl.name]: v })}
                                    />
                                </>
                            ) : (
                                <div className={styles.actionBox}>
                                    <img
                                        className={classNames(styles.icon, { [styles.isRotatedArrow]: isShowControls })}
                                        src={arrow}
                                        alt="arrow"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    {!!values.length && (
                        <div className={classNames(styles.controls, { [styles.isVisibleControls]: isShowControls })}>
                            {children}
                        </div>
                    )}
                </div>
            ) : (
                children
            )}
        </li>
    )
}

export default Group
